import { useEffect, useState } from "react";
import type { ToolsTreeNode, ToolsType } from "../../model/types";
import { useWorkspaceToolsApi } from "../api/workspaceToolsApi";
import { useWorkspaceToolsStore } from "../store/useWorkspaceToolsStore";

type ToolsTree = { nodes: ToolsTreeNode[] | null; failed: boolean };

export const useToolsTree = (type: ToolsType, enabled: boolean): ToolsTree => {
	const api = useWorkspaceToolsApi();
	const revision = useWorkspaceToolsStore((store) => store.revision);
	const [tree, setTree] = useState<ToolsTree>({ nodes: null, failed: false });

	// biome-ignore lint/correctness/useExhaustiveDependencies: a new state revision means the tree may have changed
	useEffect(() => {
		if (!enabled) return;
		let cancelled = false;
		void api.getTree(type).then((result) => {
			if (cancelled) return;
			setTree((previous) => (result.ok ? { nodes: result.value, failed: false } : { ...previous, failed: true }));
		});
		return () => {
			cancelled = true;
		};
	}, [api, type, revision, enabled]);

	return tree;
};
